import React, { useState, useRef, useEffect } from "react";

const slidesData = [
  {
    id: 1,
    title: "Graph IO",
    image: process.env.PUBLIC_URL + "/images/projects/graphio.png",
    description: "A complex mobile puzzle game, with over 50 levels.",
    link: "https://jekuper.itch.io/graph-io"
  },
  {
    id: 2,
    title: "Ronikara",
    image: process.env.PUBLIC_URL + "/images/projects/ronikara.png",
    description: "First Person Multiplayer Game with unique techniques.",
    link: "https://jekuper.itch.io/ronikara"
  },
  {
    id: 3,
    title: "Meta Cube",
    image: process.env.PUBLIC_URL + "/images/projects/metacube.png",
    description: "A fun little game about mutations.",
    link: "https://jekuper.itch.io/metacube"
  },
  {
    id: 4,
    title: "Demo 1",
    image: process.env.PUBLIC_URL + "/images/projects/demo.png",
    description: "A tech demo of 3D procedural dungeon generation.",
    link: "https://github.com/jekuper/proceduralDungeon3DGame"
  },
  {
    id: 5,
    title: "Giga Wolf",
    image: process.env.PUBLIC_URL + "/images/projects/gigawolf.png",
    description: "A casual PC game with simple animal simulation.",
    link: "https://jekuper.itch.io/wolf-simulator"
  },
  {
    id: 6,
    title: "Emotional Maze",
    image: process.env.PUBLIC_URL + "/images/projects/maze.png",
    description: "A puzzle game with procedural maze.",
    link: "https://jekuper.itch.io/emotional-maze"
  },
  {
    id: 7,
    title: "Card Trainer",
    image: process.env.PUBLIC_URL + "/images/projects/cardtrainer.png",
    description: "A flashcard based language learning app.",
    link: "https://jekuper.itch.io/cardtrainer"
  }
];


const isMobileOrTablet = () => window.innerWidth < 1200;

const Carousel = ({ onHoverChange }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(isMobileOrTablet());
  const carouselRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(isMobileOrTablet());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSlideClick = (index) => {
    if (!isMobile) return;
    setHoveredIndex((prev) => (prev === index ? null : index));
    onHoverChange(!(hoveredIndex === index)); // toggle
  };

  const handleMouseEnter = (index) => {
    if (isMobile) return;
    setHoveredIndex(index);
    onHoverChange(true);
  };

  const handleMouseLeave = () => {
    if (isMobile) return;
    setHoveredIndex(null);
    onHoverChange(false);
  };

  const scrollLeft = () => {
    carouselRef.current?.scrollBy({ left: -carouselRef.current.offsetWidth / 2, behavior: "smooth" });
  };

  const scrollRight = () => {
    carouselRef.current?.scrollBy({ left: carouselRef.current.offsetWidth / 2, behavior: "smooth" });
  };

  return (
    <div className="carousel-container">
      {!isMobile && (
        <button className="nav-button left" onClick={scrollLeft}>
          <img
            style={{ maxWidth: "100%", maxHeight: "100%" }}
            src={`${process.env.PUBLIC_URL}/images/ChevronLeft.png`}
            alt="Left Arrow"
          />
        </button>
      )}

      <div className="sliders-wrapper" ref={carouselRef} style={{ overflowX: isMobile ? "auto" : "hidden" }}>
        {slidesData.map((slide, index) => (
          <div
            key={index}
            className={`slide ${hoveredIndex === index ? "hovered" : ""}`}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
            onClick={() => handleSlideClick(index)}
          >
            <div className="box">
              <div className={`text ${index % 2 === 0 ? "top" : "bottom"}`}>{slide.description}</div>
            </div>
            <a href={slide.link}>
            <img
              className={hoveredIndex === index ? "hovered" : ""}
              src={slide.image}
              alt={slide.title}
            />
              <img
                src={`${process.env.PUBLIC_URL}/images/link-icon.png`} // use your icon here
                alt="Link"
                className="link-icon"
              />
              </a>
          </div>
        ))}
      </div>

      {!isMobile && (
        <button className="nav-button right" onClick={scrollRight}>
          <img
            style={{ maxWidth: "100%", maxHeight: "100%", transform: "scaleX(-1)" }}
            src={`${process.env.PUBLIC_URL}/images/ChevronLeft.png`}
            alt="Right Arrow"
          />
        </button>
      )}
    </div>
  );
};

export default Carousel;
